import { useEffect, type ReactNode } from "react";
import { useOkta } from "./OktaProvider";

interface AuthGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function AuthGuard({ children, fallback = null }: AuthGuardProps): ReactNode {
  const { authState, isAuthenticated, signIn } = useOkta();

  useEffect(() => {
    if (authState && !authState.isPending && !isAuthenticated) {
      void signIn();
    }
  }, [authState, isAuthenticated, signIn]);

  if (!isAuthenticated) return fallback;
  return children;
}
